import { render } from "./BundlesPage.vue?vue&type=template&id=4dba7431"
import script from "./BundlesPage.vue?vue&type=script&lang=js"
export * from "./BundlesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__